const ALLOWED_FILE_TYPES = [
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
]
const ALLOW_MULTIPLE_FILES = false

export const MB_BYTES = 1048576
export const MAX_SIZE_MB = 10

export const ALLOWED_POWER_OF_ATTORNEY_FILE_TYPES = [
  'image/png',
  'application/pdf',
  'image/jpeg',
]
export const MAX_SIZE_POWER_OF_ATTORNEY_MB = 5

const config = {
  ALLOWED_FILE_TYPES,
  ALLOW_MULTIPLE_FILES,
  ALLOWED_POWER_OF_ATTORNEY_FILE_TYPES,
}

export default config
